'use client';

import { Button, HStack, Spacer, StackProps } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

type Props = StackProps & {
    backPath?: string;
    continuePath?: string;
    continueButtonText?: string;
    continueButtonColor?: string;
    disableContinueButton?: boolean;
    beforeContinueFn?: () => boolean;
    overloadContinueFn?: () => void;
};

export const NavigateBar = (props: Props) => {
    const {
        backPath,
        continuePath,
        disableContinueButton = false,
        continueButtonText,
        continueButtonColor,
        overloadContinueFn,
        beforeContinueFn,
        ...rest
    } = props;
    const { t } = useTranslation();
    const navigate = useNavigate();

    let continueFn: (() => void) | undefined = undefined;
    if (overloadContinueFn) {
        continueFn = () => overloadContinueFn();
    } else if (!overloadContinueFn && beforeContinueFn && continuePath) {
        continueFn = () => {
            if (beforeContinueFn()) {
                navigate(continuePath);
            }
        };
    } else if (!overloadContinueFn && !beforeContinueFn && continuePath) {
        continueFn = () => {
            navigate(continuePath);
        };
    } else {
        continueFn = () => console.error('There should be a method');
    }
    return (
        <HStack {...rest}>
            <Spacer />
            {backPath && (
                <Button rounded="lg" fontWeight="600" onClick={() => navigate(backPath)} bg="brand.100">
                    {t('back')}
                </Button>
            )}
            {(typeof continueFn !== 'undefined' || continuePath) && (
                <Button
                    onClick={() => continueFn()}
                    bg={continueButtonColor || 'brand.100'}
                    disabled={disableContinueButton}
                    rounded="lg"
                    fontWeight="600"
                >
                    {continueButtonText || t('continue')}
                </Button>
            )}
        </HStack>
    );
};
